__turbopack_context__.v({
  "active": "pGhzOG_active",
  "articleItem": "pGhzOG_articleItem",
  "articleList": "pGhzOG_articleList",
  "backButton": "pGhzOG_backButton",
  "categoryContent": "pGhzOG_categoryContent",
  "categoryHeader": "pGhzOG_categoryHeader",
  "categoryTitle": "pGhzOG_categoryTitle",
  "categoryTree": "pGhzOG_categoryTree",
  "categoryWrapper": "pGhzOG_categoryWrapper",
  "chevron": "pGhzOG_chevron",
  "expanded": "pGhzOG_expanded",
  "hasActive": "pGhzOG_hasActive",
  "header": "pGhzOG_header",
  "item": "pGhzOG_item",
  "link": "pGhzOG_link",
  "list": "pGhzOG_list",
  "menu": "pGhzOG_menu",
  "text": "pGhzOG_text",
  "title": "pGhzOG_title",
});
